import AdminReviewList from './AdminReviewList';
export default AdminReviewList;
